import { render, staticRenderFns } from "./CmgOffline.vue?vue&type=template&id=84463806&scoped=true&lang=pug"
import script from "./cmg-offline.ts?vue&type=script&lang=ts&external"
export * from "./cmg-offline.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgOffline.vue?vue&type=style&index=0&id=84463806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84463806",
  null
  
)

export default component.exports